import { SelectItem } from '@mantine/core';

const getLanguageOptions = (arr: string[]) => {
  return arr.reduce((acc, item) => {
    if (item === 'ja') {
      acc.push({
        label: '日本語',
        value: item,
      });
    }

    if (item === 'en') {
      acc.push({
        label: 'English',
        value: item,
      });
    }

    if (item === 'zh-Hans') {
      acc.push({
        label: '中文',
        value: item,
      });
    }

    if (item === 'ko') {
      acc.push({
        label: '한국어',
        value: item,
      });
    }

    return acc;
  }, [] as SelectItem[]);
};

export const useLanguageOptions = () => {
  const supportedLanguage = ['ja', 'en', 'zh-Hans', 'ko'];

  const languageOptions = getLanguageOptions(supportedLanguage);

  return languageOptions;
};
